import * as React from "react"

export const TerminalIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.744 26a2.327 2.327 0 01-1.71-.7 2.327 2.327 0 01-.7-1.71V8.41c0-.673.233-1.243.7-1.71a2.327 2.327 0 011.71-.7h20.512c.674 0 1.244.233 1.71.7.467.467.7 1.037.7 1.71v15.18c0 .673-.233 1.243-.7 1.71-.466.467-1.036.7-1.71.7H5.744zm0-2h20.512a.392.392 0 00.282-.128.392.392 0 00.129-.282V10.667H5.333V23.59c0 .102.043.196.129.282a.392.392 0 00.282.128zm6.297-6.667L9.277 14.57a.948.948 0 01-.294-.702.957.957 0 01.314-.703c.199-.184.433-.278.703-.28a.949.949 0 01.703.293l3.312 3.313c.241.24.362.522.362.843 0 .322-.12.603-.362.844l-3.325 3.326a.946.946 0 01-.686.28.953.953 0 01-.707-.293.937.937 0 01-.276-.69.94.94 0 01.276-.69l2.744-2.777zm5.292 5a.967.967 0 01-.712-.287.967.967 0 01-.288-.713c0-.283.096-.521.288-.712a.967.967 0 01.712-.288h5.334c.283 0 .52.096.712.288a.967.967 0 01.288.712.967.967 0 01-.288.713.967.967 0 01-.712.287h-5.334z"
    ></path>
  </svg>
)
